module.exports = __webpack_public_path__ + "img/AL804-1-EN.21cb3a14.jpg";